import mediasMixins from "root/mixins/mediasMixin.js";
import wishlistMixin from "root/mixins/wishlistMixin.js";
import utilsMixin from "root/mixins/utilsMixin.js";
const axios = require("axios");

export default {
  name: "product-grid",
  mixins: [mediasMixins, utilsMixin, wishlistMixin],

  props: ["rawresults", "page", "isLoggedIn"],

  data() {
    return {
      nextPage: 1,
      iswishlist: false,
      limitexceded: false,
      isLoading: false,
      results: [],
    };
  },

  methods: {
    callNextPage: function() {
      if (this.limitexceded || !this.$root.nextPageExists || this.isLoading) {
        return;
      }
      this.isLoading = true;
      var url;
      if (this.page === "category") {
        url = "c/" + this.categorycode + "/results";
      } else {
        url = "/search/results";
      }

      this.$http
        .get(url, {
          params: {
            q: this.decodeHTML(this.currentquery.query.value),
            page: this.nextPage,
          },
        })
        .then(
          (response) => {
            this.nextPage = this.nextPage + 1;
            this.results = this.results.concat(response.body.results);
            this.isLoading = false;
            if (response.body.pagination.numberOfPages <= this.nextPage) {
              this.limitexceded = true;
            }
          },
          (error) => {
            this.isLoading = false;
            console.error(error);
          }
        );
    },
  },

  computed: {
    currentquery() {
      return _.get(this, "$root.searchPageData.currentQuery");
    },
    categorycode() {
      return _.get(this, "$root.searchPageData.categoryCode");
    },
  },

  watch: {},

  created() {
    this.results = this.isJson(this.rawresults);
    this.$root.$on(
      "update-product-grid-results",
      _.bind(function(results) {
        this.nextPage = 1;
        this.limitexceded = false;
        this.isLoading = false;
        this.results = results;
      }, this)
    );
  },

  mounted: function() {},
};



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/productgrid/productgrid.js